//put jquery at first
import $ from "jquery";

window.$ = $;
window.jQuery = $;
/**
 * iml api adapter
 * @param url
 * @param requestVO
 * @param successCallback
 * @param errorCallback
 */
window.callImlApi = function (url, requestVO, successCallback, errorCallback) {
    if (window.imlApiService) {
        window.imlApiService.post(url, requestVO, successCallback, errorCallback);
    }
};

/**
 * iml api adapter
 * @param url
 * @param method
 * @param requestVO
 * @param successCallback
 * @param errorCallback
 */
window.callImlApiWithMethod = function (url, method ,requestVO, successCallback, errorCallback) {
    if (window.imlApiService) {
        window.imlApiService[method.toLowerCase()](url, requestVO, successCallback, errorCallback);
    }
};
window.IS_ELECTRON = __IS_ELECTRON__;
